import { InterviewKind } from '@Domain/Enums/Interviews/InterviewKind';
import { openInterviewToDelete } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/Signals/interviewToDeleteSignal';
import { Trash2 } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';

const DELETE_LABELS: Readonly<Record<InterviewKind, string>> = Object.freeze({
	[InterviewKind.CONVERSATION]: "Supprimer l'entretien",
	[InterviewKind.NOTES]: 'Supprimer la prise de notes',
	[InterviewKind.TEXT]: 'Supprimer le texte saisi',
});

type Props = {
	readonly kind: InterviewKind;
	readonly interviewId: number;
	/** Set while a deletion is running, so the action cannot be triggered twice. */
	readonly isDisabled: boolean;
};

/** Opens the confirmation; the server decides whether the deletion goes through. The dialog is mounted by the screen. */
const DeleteInterviewAction: React.FC<Props> = ({ kind, interviewId, isDisabled }) => {
	const handleClick = React.useCallback(() => {
		openInterviewToDelete(interviewId);
	}, [interviewId]);

	return (
		<Button
			type="button"
			text
			severity="danger"
			label={DELETE_LABELS[kind]}
			icon={<Trash2 size={16} />}
			disabled={isDisabled}
			onClick={handleClick}
		/>
	);
};

export default DeleteInterviewAction;
